import 'core-js/es6/promise';
import 'core-js/fn/array/find';
import 'core-js/fn/object/assign';

// el.closest()
if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    let el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      const matches = (el.msMatchesSelector || el.matches).bind(el);
      if (matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

// el.remove()
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null) { this.parentNode.removeChild(this); }
      }
    });
  });
}([Element.prototype, CharacterData.prototype, DocumentType.prototype]));

(function () {
  if (typeof window.CustomEvent === 'function') return;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
}());



// WEBPACK FOOTER //
// ./app/Assets/js/polyfills.js